module.exports = __webpack_public_path__ + "85e6ff7914212f619288f4b5fd1d6451.pdf";